import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@follosoft/react-components";

export function usePaymentPlansAvailable(contractId?: number | string) {
  return useQuery({
    queryKey: ["available-payment-plans", Number(contractId)],
    queryFn: async () => {
      if (!contractId) return [];

      const res = await axiosInstance().get(
        `/folloportal/payment-plans/available`,
        {
          params: {
            "meta[contract_id]": contractId,
          },
        }
      );

      return res.data.data;
    },
    enabled: !!contractId,
    staleTime: 0,
  });
}
